import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { SERVER_API_URL } from '../../../app.constants';
import { filter } from 'rxjs';

@Component({
  selector: 'app-payspot',
  standalone: true,
  templateUrl: './payspot.component.html',
  styleUrl: './payspot.component.scss',
  imports: [CommonModule, HttpClientModule, RouterModule]
})
export class PayspotComponent {
 status: 'pending' | 'success' | 'error' = 'pending';

  constructor(private route: ActivatedRoute, private http: HttpClient,private router: Router) { }

 ngOnInit(): void {
  const order  = this.route.snapshot.queryParamMap.get('order');
  const status = this.route.snapshot.queryParamMap.get('status');

  if (status === 'cancel') {
    this.status = 'error';
    return;
  }

  if (status === 'uspesnoPlacenPaket') {
    this.status = 'success';
    return;
  }

  if (status === 'neUspesnoPlacenPaket') {
    this.status = 'error';
    return;
  }

  if (status === 'error') {
    this.status = 'error';
    return;
  }

  if (status === 'success' && order) {
    this.pollPaymentStatus(order, 0);
  } else {
    this.status = 'error';
  }
}

private pollPaymentStatus(order: string, attempt: number): void {
  if (attempt >= 10) {
    // Nakon 10 pokušaja (20 sekundi) odustajemo
    this.status = 'error';
    return;
  }

  this.http.get<{status: string}>(`${SERVER_API_URL}api/invoices/paymentStatus`, {
    params: new HttpParams().set('order', order)
  }).subscribe({
    next: (res) => {
      if (res.status === 'V') {
        this.status = 'success';
        setTimeout(() => {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('order');
          currentUrl.searchParams.set('status', 'uspesnoPlacenPaket');
          window.location.href = currentUrl.toString();
        }, 2500);

      } else if (res.status === 'PAYSPOT_ERROR') {
        this.status = 'error';
        setTimeout(() => {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('session_id');
          currentUrl.searchParams.set('status', 'neUspesnoPlacenPaket');
          window.location.href = currentUrl.toString();
          }, 2500);
      } else {
        // Još uvek PENDING – pokušaj ponovo za 2 sekunde
        setTimeout(() => this.pollPaymentStatus(order, attempt + 1), 2000);
      }
    },
    error: () => {
      setTimeout(() => this.pollPaymentStatus(order, attempt + 1), 2000);
    }
  });
}

  goToDashboard() {
    window.location.href = '/dashboard';
  } 

  retry() {
    window.location.reload();
  }

   
}
